import front from './view';

export default [
  {
    path: 'new',
    redirect: 'new/guide',
  },
  {
    path: 'change',
    redirect: 'change/guide',
  },
  {
    path: 'new/guide',
    component: front('/anew/guide'),
    props: { type: 'NEW' },
  },
  {
    path: 'change/guide',
    component: front('/anew/guide'),
    props: { type: 'ACH' },
  },
  {
    path: 'new/fillForm', // 신청서작성
    component: front('/anew/fillForm'),
    props: { type: 'NEW' },
    meta: { requireRole: 'COMPANY' },
  },
  {
    path: 'change/fillForm', // 신청서작성
    component: front('/anew/fillForm'),
    props: { type: 'ACH' },
    meta: { requireRole: 'COMPANY' },
  },
  {
    path: 'change/selectItem', // 신청서작성
    component: front('/anew/selectItemForChange'),
    props: { type: 'ACH' },
    meta: { requireRole: 'COMPANY' },
  },
  {
    path: 'new/done', // 신청접수 완료
    component: front('/anew/requestDone'),
    props: { type: 'NEW' },
  },
  {
    path: 'change/done', // 신청접수 완료
    component: front('/anew/requestDone'),
    props: { type: 'ACH' },
  },

];



// WEBPACK FOOTER //
// ./src/router/front/anew.js